import React from 'react';
import { TextField, useMediaQuery } from '@material-ui/core';
import reportSettingStyles from '../ReportSettings.style';

function RbTextField(props) {
	const { maxLength } = props;
	const isSmallScreen = useMediaQuery('(max-width:360px)');
	const classes = reportSettingStyles({ isSmallScreen });

	return (
		<TextField
			id="report-name"
			label="Report Name"
			variant="outlined"
			fullWidth
			InputProps={{
				classes: {
					input: classes.text
				}
			}}
			inputProps={{
				maxLength: maxLength
			}}
			InputLabelProps={{
				classes: {
					root: classes.text
				}
			}}
			{...props}
		/>
	);
}

RbTextField.propTypes = {};

export default RbTextField;
